<div class="badge badge-outline badge-primary">
  <div>{{ levelLabel() }}</div>
</div>
